import { action } from 'typesafe-actions'

import { Emergency, EmergenciesFilters, EmergenciesParam } from './emergencies' 

export enum emergenciesActionType {
    FETCH_EMERGENCIES = 'FETCH_EMERGENCIES',
    FETCH_EMERGENCIES_SUCCEEDED = 'FETCH_EMERGENCIES_SUCCEEDED',
    SET_CURRENT_PAGE = 'SET_CURRENT_PAGE',
    SET_FILTERS = 'SET_FILTERS',
    RESET_EMERGENCIES = 'RESET_EMERGENCIES',
    THROW_ERROR = 'THROW_ERROR',
}

export const emergenciesActions = {
  fetchEmergencies: (params?: EmergenciesParam) =>
    action(emergenciesActionType.FETCH_EMERGENCIES, params ?? {}),
  fetchEmergenciesSucceeded: (emergencies: Emergency[], totalCount?: number) =>
    action(emergenciesActionType.FETCH_EMERGENCIES_SUCCEEDED, { emergencies, totalCount }),
  setCurrentPage: (page: number) => action(emergenciesActionType.SET_CURRENT_PAGE, { page }),
  setFilters: (filters: EmergenciesFilters) =>
    action(emergenciesActionType.SET_FILTERS, { filters }),
  resetEmergencies: () => action(emergenciesActionType.RESET_EMERGENCIES),
  throwError: (error: Error) => action(emergenciesActionType.THROW_ERROR, { error }),
}
